module.exports = require("node:os");